<template>
  <div class="playlist-group">
    <div class="content">
      <div class="logo">
        <img :src="playlistGroup.thumbnail" />
        <h2>{{playlistGroup.title}}</h2>
      </div>

      <div class="info">
        <div class="left-info">
          <div>
            <age-badge :age="playlistGroup.minAge" />
            <season-count :amount="playlists.length" />
          </div>

          <p>{{playlistGroup.description}}</p>
        </div>
        <div class="right-info">
          <div class="advise">
            <div>!</div>
            <div v-t="'misc.ageAdvise'" />
          </div>

          <development-tags v-if="playlistGroup.tags.length > 0" :tags="playlistGroup.tags" badge />
        </div>
      </div>

      <h1 class="episodes-header" v-t="'misc.episodes'" />
      <playlist
        v-for="playlist in playlists"
        :key="playlist.id"
        :id="playlist.id"
        :playlistGroupId="playlistGroupId"
        :show-title="playlists.length > 1"
        :isDemo="demo"
        @demoActivated="$emit('demoActivated')"
      />
    </div>
  </div>
</template>

<script>
export default {
  name: 'playlist-group',
  props: {
    playlistGroupId: String,
    demo: Boolean,
    shouldAutoplay: Boolean
  },
  computed: {
    playlistGroup() {
      return this.$store.getters['contentTree/findPlaylistGroup'](this.playlistGroupId)
    },
    playlists() {
      return this.$store.getters['contentTree/findPlaylistsFromPlaylistGroup'](this.playlistGroupId)
    }
  },
  created() {
    if (!this.playlistGroup) {
      this.$router.home(true)
    }
    if (this.shouldAutoplay) {
      const playlistGroupId = this.playlistGroup.id
      const playlistId = this.playlists[0].id
      const id = this.playlists[0].playables[0].contentId
      this.$router.replace({
        name: 'watch-video',
        params: {
          playlistGroupId,
          playlistId,
          id
        }
      })
    }
  }
}
</script>

<style lang="scss">
.playlist-group {
  display: flex;
  flex-direction: column;
  align-items: center;
  background-color: #FAFAFA;

  .cover {
    height: 20vh;
    width: 100%;
    max-height: 350px;
    margin-bottom: 3vh;

    @media screen and (max-width: 1100px) {
      height: 200px;
      margin-bottom: 0;
    }

    @media screen and (max-width: 725px) {
      height: 175px;
    }

    img {
      width: 100%;
      height: 20vh;
      object-fit: cover;
    }
  }

  .content {
    display: flex;
    flex-direction: column;
    width: min-content;
    margin: 3vh auto 0;

    .logo {
      display: flex;
      flex-direction: row;
      align-items: flex-end;
      width: 100%;
      margin-left: 16px;
      margin-bottom: 1rem;

      @media screen and (max-width: 1100px) {
        flex-direction: column;
        align-items: center;
        margin-left: 0;
        padding: 0 16px;
      }

      & > h2 {
        font-size: 1.8rem;
        margin-bottom: 0;
        margin-left: 1rem;

        @media screen and (max-width: 1100px) {
          text-align: center;
          margin-top: 1rem;
          margin-left: 0;
        }
      }

      img {
        width: 200px;
        height: 146px;
        border-radius: 16px;
        border: $video-thumbnail-border;
      }
    }

    .info {
      display: inline-flex;
      flex-flow: row wrap;
      width: 100%;
      margin-bottom: 15px;

      & > div {
        display: flex;
        flex-direction: column;
        padding: 16px;
        min-width: 300px;
        flex: 1 1 50%;
      }

      .left-info {
        @media screen and (max-width: 1100px) {
          padding-bottom: 0;
        }

        & > div {
          display: flex;
          flex-direction: row;
          align-items: center;
        }

        p {
          margin-top: 16px;
          font-size: 1.2rem;
          line-height: 2rem;
          font-weight: normal;
        }
      }

      .right-info {
        @media screen and (max-width: 1100px) {
          padding-top: 6px;
          flex-direction: column-reverse;
        }

        .advise {
          display: flex;
          align-items: center;
          border-radius: 8px;
          padding: 16px;
          background-color: $advise-background-color;

          div:first-child {
            text-align: center;
            min-width: 32px;
            height: 32px;
            font-size: 1.6rem;
            line-height: 32px;
            border-radius: 100%;
            background-color: $advise-exclamation-background-color;
            color: $advise-exclamation-color;
          }

          div:last-child {
            margin-left: 14px;
            font-weight: bold;
            font-size: 1rem;
            line-height: 16px;
          }
        }

        & > .development-tags {
          margin-top: 30px;

          @media screen and (max-width: 1100px) {
            margin-top: 0;
            margin-bottom: 30px;
          }
        }
      }
    }

    .episodes-header {
      padding-left: 16px;
      font-size: 1.6rem;
    }
  }
}
</style>
